/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// for testing dev=true 
let sPageURL = window.location.search.substring(1);
if('dev=true' === sPageURL){
   console.log('now you are test mode');
    const j_no = jQuery.noConflict();
    j_no(document).ready(function(){
		
      
      j_no('button[data-action=add-to-cart]').on('click', function(event){
         event.preventDefault(); // Prevent form to be submitted
        event.stopPropagation(); // First, we switch the status of the button
        
        j_no('#main-info-modal').css('display', 'block');
        
        console.log('event stop is working');
      });
      
     
      j_no(window).on("click", function(e){
        if(e.target.id === 'main-info-modal'){
        	j_no('#main-info-modal').css('display', 'none');
        }
      });
      
      
      j_no('#pet-other-medics').on('change', function(){
        if( 'yes' === j_no(this).val()){
        	j_no(".show-other-medics").fadeIn(500);
        }else{
        	j_no(".show-other-medics").fadeOut(500);
        }
      });
      
      
      j_no('.pet-send-info').on('click', function(){
      	event.preventDefault(); // Prevent form to be submitted
        event.stopPropagation(); // First, we switch the status of the button
        let pet_info  = j_no('#pet-info').val();
        console.log(pet_info);
        
        j_no.ajax({
            url: '/ajax-popup',
            type: 'POST',
            data: pet_info,
            beforeSend: function(){
               j_no('.insert-ajax').html('');
               j_no('.loadingio-spinner-spinner-ew7g53u2i').css('display', 'block');
            },
            success: function (response) {
               // response = JSON.parse(response);
               console.log(response);
             

               //j_no('.insert-ajax').html(response);
               //j_no('.loadingio-spinner-spinner-ew7g53u2i').css('display', 'none');

            }
         });
        
      });
      
    });
    
  
}